import { useEffect } from 'react';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { ArrowRight } from 'lucide-react';

export default function RoofingWood() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navbar />

      {/* HERO */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="relative h-[600px] mb-0 overflow-hidden"
      >
        <img
          src="https://media.base44.com/images/public/69cd72579c1c23d07f425ea3/5aa9e97ea_28mmtermotre.jpg"
          alt="Tretak - 28 mm termotre"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/10 to-black/20"></div>
        <div className="absolute inset-0 flex flex-col justify-end p-12 z-10">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <p className="text-sm tracking-widest-2xl font-body uppercase text-white/60 mb-6">Artikkel 1</p>
            <h1 className="font-heading text-6xl md:text-7xl lg:text-8xl font-light leading-[1.0] text-white mb-6">
              Tretak, 28 mm termotre
            </h1>
            <p className="font-body text-white/80 text-2xl max-w-2xl leading-relaxed">
              Varmt, taktilt og naturbundet, tre som arbeider med klimaet
            </p>
          </motion.div>
        </div>
      </motion.div>

      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <motion.section
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="py-20"
        >
          <div className="max-w-4xl">
            <h2 className="font-heading text-5xl font-light leading-[1.1] mb-8 text-[#2a1810]">
              Tre som eldes med byggingen
            </h2>
            <p className="font-body text-2xl text-foreground/70 leading-relaxed mb-6">
              Termotre er nordisk tre som er varmbehandlet for å bli mer stabilt og motstandsdyktig. Det gir taket en varm, taktil overflate som hele tiden forandrer seg med solen og været.
            </p>
            <p className="font-body text-2xl text-foreground/70 leading-relaxed mb-12">
              Et tretak skaper en helt annen opplevelse enn metall. Det lar badstuen tre frem som et trebygget volum og gir den en varmer karakter. Behandlingen gjør treet mer motstandsdyktig mot fuktighet og temperatursvingninger — en stor fordel i nordisk klima.
            </p>

            <div className="grid md:grid-cols-2 gap-6 mb-16">
              {[
                { 
                  title: 'Naturlig aldringsprocess',
                  desc: 'Treet eldes gradvis fra gullbrunt til sølvgrått. Denne forandringen skjer organisk og gjør badstuen til en del av naturens syklus.' 
                },
                { 
                  title: 'Materialet arbeider',
                  desc: 'Termotre ekspanderer og trekker seg sammen med fuktighet og temperatur. Det er ikke en svakhet — det er treets måte å fungere på.' 
                },
                { 
                  title: 'Vedlikehold',
                  desc: 'Enkel inspeksjon og rensing av nedfallsrør og drenering. Ingen farging eller behandling nødvendig.' 
                },
                { 
                  title: 'Varme og eleganse',
                  desc: 'Treet gir taket en myk, naturlig look som fungerer ekskepsjonelt godt i skogsettinger.' 
                }
              ].map((item, idx) => (
                <motion.div
                  key={idx}
                  whileHover={{ y: -4 }}
                  className="bg-white border border-border/20 rounded-[8px] p-8 hover:border-[#2d5a3d] hover:shadow-md transition-all"
                >
                  <h3 className="font-heading text-2xl font-light text-[#2a1810] mb-3">{item.title}</h3>
                  <p className="font-body text-2xl text-foreground/70">{item.desc}</p>
                </motion.div>
              ))}
            </div>

            <div className="bg-gradient-to-br from-[#2d5a3d]/10 to-transparent border-l-4 border-[#2d5a3d] rounded-[8px] p-8 mb-12">
              <p className="font-body text-2xl text-foreground/70 leading-relaxed">
                <strong className="text-[#2a1810]">Valg av termotre</strong> er for deg som ønsker en avtakende, organisk aldring. Det passer særlig godt i naturlige omgivelser hvor badstuen skal følge landskapet.
              </p>
            </div>

            <motion.a
              whileHover={{ scale: 1.02 }}
              href="/laer-mer-handverk"
              className="inline-flex items-center gap-2 px-8 py-4 bg-[#2a1810] text-white font-body tracking-widest text-2xl font-semibold rounded-[4px] hover:bg-[#2a1810]/90 transition-all"
            >
              Tilbake til Lær Mer <ArrowRight size={16} />
            </motion.a>
          </div>
        </motion.section>
      </div>

      <Footer />
    </div>
  );
}